import { Box, Button, Heading } from '@zillow/constellation-10';
import { ExitReason } from '../../../models';
import { useIdVerificationCallbacks } from '../../Idv/IdvContext';

export default function Header() {
  const { onExit } = useIdVerificationCallbacks();

  return (
    <header style={{ width: '100%' }}>
      <Box
        css={{
          display: 'flex',
          marginTop: 'default',
          marginBottom: 'default',
          marginLeft: { base: 'default', lg: 'looser' },
          marginRight: { base: 'default', lg: 'looser' },
          justifyContent: 'space-between',
        }}
      >
        <Box css={{ display: 'flex', alignItems: 'center' }}>
          <Heading level={1} textStyle="heading-xs" css={{ marginRight: 'default' }}>
            Identity verification
          </Heading>
        </Box>
        <Button
          tone="neutral"
          emphasis="outlined"
          onClick={() =>
            onExit({
              reason: ExitReason.ModalClose,
              success: false,
            })
          }
        >
          Exit
        </Button>
      </Box>
    </header>
  );
}
